/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const DefaultPlanType="FD";
export const planTypeMedicaid="Medicaid";
export const radioGroupLabelName="Plan Type";
export const rebateProgramLabelName="Rebate Program";
export const quarterLabelName="Quarter";